export enum LanguagesApp {
  English = "en",
  Arabic = "ar",
}
